import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        recaComercializadores: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Recaudo?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("reca_comercializadores/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarRecaComercializadores(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarRecaComercializadores(page) {
        Swal.showLoading();
        let bestado = document.getElementById('bestado').value;
        let bperiodo = document.getElementById('bperiodo').value;
        let bmunicipio = document.getElementById('bmunicipio').value;
        let bcomercializador = document.getElementById('bcomercializador').value;
        if (bestado == '') {
            bestado = 0;
        }
        if (bperiodo == '') {
            bperiodo = 0;
        }
        if (bmunicipio == '') {
            bmunicipio = 0;
        }
        if (bcomercializador == '') {
            bcomercializador = 0;
        }
        authAxios.get("reca_comercializadores/index/" + bestado + "/" + bperiodo + "/" + bmunicipio + "/" + bcomercializador + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', recaComercializadores: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarRecaComercializadores(1);
    }
    render() {
        const { load, recaComercializadores, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddRecaComercializador"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Recaudo</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Recaudos Comercializadoras</h4>
                            <hr />
                            <div className="row">
                            <   div className='col-md-12'>
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingOne">
                                                <button style={{ fontSize: 14 }} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <b>FILTROS</b>
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne">
                                                <div className="accordion-body">
                                                    <div className='row'>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bestado">Estado Factura</label>
                                                            <select name="bestado" id="bestado"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                    <option value="">-</option>
                                                                    <option value="1">PAGADO</option>
                                                                    <option value="2">PENDIENTE DE PAGO</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-2">
                                                            <label htmlFor="bperiodo">Periodo</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="number" id="bperiodo" name="bperiodo" placeholder="PERIODO" min="0" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="bmunicipio">Municipio</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="bmunicipio" name="bmunicipio" placeholder="MUNICIPIO" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <label htmlFor="bcomercializador">Comercializadora</label>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="bcomercializador" name="bcomercializador" placeholder="COMERCIALIZADORA" className="form-control form-control-sm" />
                                                        </div>
                                                        <div style={{ marginTop: 32 }} className="col-xl-1">
                                                            <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarRecaComercializadores(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className='col-xl-12'>
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">DEPARTAMENTO</th>
                                                <th className="align-middle">MUNICIPIO</th>
                                                <th className="align-middle">COMERCIALIZADORA</th>
                                                <th className="align-middle">VALOR RECAUDO</th>
                                                <th className="align-middle">PERIODO</th>
                                                <th className="align-middle">OPCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                recaComercializadores.map((itemRecaComercializadores) => (
                                                    <tr key={itemRecaComercializadores.ID_RECAUDO}>
                                                        {
                                                            (() => {
                                                                switch (itemRecaComercializadores.ESTADO_RECAUDO) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PP</span></td>)

                                                                }
                                                            })()
                                                        }
                                                        <td>{itemRecaComercializadores.DEPARTAMENTO}</td>
                                                        <td>{itemRecaComercializadores.MUNICIPIO}</td>
                                                        <td>{itemRecaComercializadores.COMERCIALIZADOR}</td>
                                                        <td><b>$ </b>{currencyFormat(itemRecaComercializadores.VALOR_RECAUDO)}</td>
                                                        <td>{itemRecaComercializadores.PERIODO_FACTURA}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpRecaComercializadores/" + itemRecaComercializadores.ID_RECAUDO}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.borrarRegistros(itemRecaComercializadores.ID_RECAUDO)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">P</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PAGADO</b></span>&nbsp;
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">PP</span>
                            <span style={{ fontSize: 11, textTransform: 'uppercase' }}> = <b>PENDIENTE PAGO</b></span>&nbsp;
                            <nav style={{ marginTop: 15 }} aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaComercializadores(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaComercializadores(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarComercializador(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaComercializadores(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRecaComercializadores(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;